import { NavigateService } from 'src/app/services/navigate.service';
import { firstValueFrom } from 'rxjs';
import { Injectable, Type, ComponentFactoryResolver } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { ServerTypes } from 'src/app/models/servers';
import { HttpClient } from '@angular/common/http';
import { ModalService } from 'src/app/modal/modal.service';
import { EditFormService } from '../../../services/edit-form.service';
import { EsbService } from 'src/app/services/esb.service';
import { ToastrService } from 'ngx-toastr';

export const ComponentTypesMap: { [key: string]: Type<any> } = {
  //e.g. "TestModule": TestModuleComponent,
};

const parseKeyValuePairs = (
  keysAndValues: string[]
): { key: string; value: any }[] => {
  const keyValuePairs = [];
  for (let i = 0; i < keysAndValues.length; i += 2) {
    const currentItem = keysAndValues[i];
    if (currentItem.endsWith('=')) {
      keyValuePairs.push({
        key: currentItem.slice(0, currentItem.indexOf('=')),
        value: keysAndValues[i + 1],
      });
    } else {
      throw new Error(
        'Invalid component initialization arguments. Example valid argument: ["key=", "{value}", "key2=", "value2"]'
      );
    }
  }

  return keyValuePairs;
};

const parseKeyValue = (key: any, value: any): any => {
  if (typeof key === 'number') return Number(value);
  else if (typeof key === 'boolean') return JSON.parse(value);

  return value;
};

@Injectable({ providedIn: 'root' })
export class CellActionHandlersService {
  constructor(
    private toastr: ToastrService,    
    private navigateService: NavigateService,
    private esbService: EsbService,

    private datePipe: DatePipe,
    private apiService: ApiService,
    private httpClient: HttpClient,
    private modalService: ModalService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private editFormService: EditFormService
  ) {}

  navigateToListsClaimsList(event:any, date: string): void {
    let year = this.datePipe.transform(date, 'yyyy');
    let month = this.datePipe.transform(date, 'MM');

    this.navigateService.navigateToListsClaimsList(year, month);
  }
  post(event:any, value1:string, value2: string) {
   
      NProgress.start();
      const url = this.apiService.joinUrl(ServerTypes.boapi, value1 + '/' + value2);
      this.httpClient.post(url, null).subscribe(res => {
          window.location.reload();
      });

  }

    postWithConfirm(event:any, value1:string, value2: string) {
      if (confirm(`Are you sure you want post`)) {
        NProgress.start();
        const url = this.apiService.joinUrl(ServerTypes.boapi, value1 + '/' + value2);
        this.httpClient.post(url, null).subscribe(res => {
            window.location.reload();
        });
      }
    }

    postWithToastr(event:any, serverType:ServerTypes, value1:string, success:string, reload:boolean = false) {
        NProgress.start();
        const url = this.apiService.joinUrl(serverType, value1);
        this.httpClient.post(url, null).subscribe(res => {
          this.toastr.success(success);
          NProgress.done();
            if (reload) window.location.reload();
        }, err => {
          this.toastr.error("Error");
          NProgress.done();
        });      
    }

    deleteWithToastr(event:any, serverType:ServerTypes, value1:string, success:string) {            
      if (confirm(`Are you sure you want delete`)) {
        NProgress.start();
      
        const url = this.apiService.joinUrl(serverType, value1);
        this.httpClient.delete(url).subscribe(res => {
          this.toastr.success(success);
          NProgress.done();
          window.location.reload();
        }, err => {
          this.toastr.error("Error");
          NProgress.done(); 
        });    
    }  
  }

  esbRetryEvent(event:any, messageId: string, eventId: string) {
      NProgress.start();
      (event.target as HTMLAnchorElement).style.display = "none";
    
      this.esbService.dispatchEvent(messageId, eventId).subscribe(res => {    
        this.toastr.success('Event retried');        
          window.location.reload();
      });
  }

  esbResetRetriesEvent(event:any, messageId: string, eventId: string) {
    NProgress.start();
    this.esbService.resetRetriesEvent(messageId, eventId).subscribe(res => {  
      this.toastr.success('Event retry reset');         
        window.location.reload();
    });
}

  esbDispatchCommand(event:any, messageId: string) {
    NProgress.start();
    this.esbService.dispatchCommand(messageId).subscribe(res => {           
        window.location.reload();
    });
  }

  navigateToEntity(event:any, entityId: string, newWindow?: boolean) {
    this.navigateService.navigateToEntity(entityId, newWindow);
  }

  navigateToMzPending(event:any, value1: string) {
    this.navigateService.navigateToMzPending(value1);
  }

  navigateToMzDecisionsPending(event:any, type: string) {
    this.navigateService.navigateToMzDecisionsPending(type);
  }

  navigateToDeicisionOrSearch(event:any, id: string) {
    if (localStorage.getItem('clientId').startsWith('9121')) {
      this.navigateService.navigateToMzDecision(id);
    } else {
      this.navigateService.navigateToSearchResults(id);
    }
  }

  navigateToRoute(event:any, ...params: string[]) {
 
    this.navigateService.navigateToRoute(...params);
  }

  openPDF(event:any, ...params: string[]) {
    this.navigateService.openPDF(...params);

  }

  navigateToRouteInTab2(event:any, ...params: string[]) {
    this.navigateService.navigateToRouteInTab2(...params);
  }
  navigateToRouteInNewWindow(event:any, ...params: string[]) {
    this.navigateService.navigateToRouteInNewWindow(...params);
  }

  openUrlNewWindow(event:any, ...params: string[]) {
    this.navigateService.openUrlNewWindow(params.toString());
  }
  
  /**
   * Opens the sidebar by extracting componentType from ComponentTypesMap and initializing its input with keysAndValues.
   * @param componentType The component type.
   * @param keysAndValues Keys and values parameters.
   * They must follow a pattern (key must end with '=' sign) and order,
   * where key appear first and it's value next. For example ["input1key=", "input1value"]
   */
  openRightSidebar(componentType: string, ...keysAndValues: string[]) {
    const typeOfComponent = ComponentTypesMap[componentType];
    if (!typeOfComponent) {
      throw new Error(
        `No component type found for ${componentType}. Available component types: [${Object.keys(
          ComponentTypesMap
        ).join(', ')}]`
      );
    }
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      typeOfComponent
    );

    this.modalService.open({
      componentFactory,
      onInit: (component) => {
        if (!keysAndValues || keysAndValues.length <= 0) {
          return;
        }
        const keyValuePairs = parseKeyValuePairs(keysAndValues);

        keyValuePairs.forEach((keyValuePair) => {
          component[keyValuePair.key] = parseKeyValue(
            component[keyValuePair.key],
            keyValuePair.value
          );
        });
      },
    });
  }

  openEditForm(event:any, editFormId: string, ...keysAndValues: string[]) {
 
    let keyValuePairs: { key: string; value: any }[];
    if (keysAndValues.length > 0) {
      keyValuePairs = parseKeyValuePairs(keysAndValues);
    }

    this.editFormService.openEditForm(editFormId, keyValuePairs);
  }

  async deleteEntity(entityName: string, entityId: string, deleteApiUrl: string): Promise<any> {
    const url = this.apiService.getCurentServer(ServerTypes.boapi);

    if (confirm(`Are you sure you want to delete ${entityName}?`)) {
     
      await firstValueFrom(this.httpClient.delete(url + deleteApiUrl + entityId), { defaultValue: undefined });
      window.location.reload();
    }
  }
}
